<template>
  <div :class="mensagemWrapperClasses">
    <chat-log-item-mensagem-referencia-conteudo-texto
      v-if="mensagem.mensagemReferenciaConteudoTexto"
      class="mb-1"
      :mensagem-referencia-conteudo-texto="mensagem.mensagemReferenciaConteudoTexto"
      :is-mensagem-do-atendente="isMensagemDoAtendente"
    />

    <div
      :class="conteudoWrapperClasses"
      style="max-width: 90% !important;"
    >
      <chat-log-item-avatar
        :atendente-nome="atendenteNome"
        :solicitante-nome="solicitanteNome"
        :is-mensagem-do-atendente="isMensagemDoAtendente"
      />

      <chat-log-item-conteudo
        :canal-tipo-id="mensagem.canalTipoId"
        :chat-bot-provedor-comunicacao-id="mensagem.chatBotProvedorComunicacaoId"
        :conteudo-texto="mensagem.conteudoTexto"
        :is-mensagem-do-atendente="isMensagemDoAtendente"
        :pode-responder-mensagem="podeResponderMensagem"
        :ticket-esta-finalizado="ticketEstaFinalizado"
        @mensagem-selecionada-para-resposta="$emit('mensagem-selecionada-para-resposta', mensagem.id)"
      />
    </div>

    <chat-log-item-anexo
      v-for="(anexo, anexoIndex) in mensagem.anexos"
      :key="anexoIndex"
      :anexo="anexo"
      :is-mensagem-do-atendente="isMensagemDoAtendente"
    />

    <chat-log-item-data-cadastro
      class="mt-1"
      :data-cadastro="mensagem.dataCadastro"
      :is-mensagem-do-atendente="isMensagemDoAtendente"
    />
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import ChatLogItemMensagemReferenciaConteudoTexto from './ChatLogItemMensagemReferenciaConteudoTexto.vue'
import ChatLogItemAvatar from './ChatLogItemAvatar.vue'
import ChatLogItemConteudo from './ChatLogItemConteudo.vue'
import ChatLogItemAnexo from './ChatLogItemAnexo.vue'
import ChatLogItemDataCadastro from './ChatLogItemDataCadastro.vue'
import TicketMensagemTipoAtorEnum from '@/models/entities/ticket/TicketMensagemTipoAtorEnum'

export default {
  emits: ['mensagem-selecionada-para-resposta'],

  components: {
    ChatLogItemMensagemReferenciaConteudoTexto,
    ChatLogItemAvatar,
    ChatLogItemConteudo,
    ChatLogItemAnexo,
    ChatLogItemDataCadastro,
  },

  props: {
    mensagem: {
      type: Object,
      required: true,
    },
    atendenteNome: {
      type: String,
      required: true,
    },
    solicitanteNome: {
      type: String,
      required: true,
    },
    isUltimaMensagem: {
      type: Boolean,
      required: true,
    },
    podeResponderMensagem: {
      type: Boolean,
      required: true,
    },
    ticketEstaFinalizado: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const isMensagemDoAtendente = computed(() => [TicketMensagemTipoAtorEnum.Agente.id, TicketMensagemTipoAtorEnum.Gestor.id].includes(props.mensagem.tipoAtorId))

    const mensagemWrapperClasses = computed(() => `
      chat-group d-flex flex-column 
      ${isMensagemDoAtendente.value ? 'align-end' : ''}
      ${props.isUltimaMensagem ? '' : 'mb-8'}
    `)

    const boxClasses = computed(() => `
      d-flex flex-column 
      ${isMensagemDoAtendente.value ? 'align-end' : ''}
    `)

    const conteudoWrapperClasses = computed(() => `
      chat-body d-inline-flex align-center
      ${isMensagemDoAtendente.value ? 'flex-row-reverse ' : ''}
    `)

    return {
      isMensagemDoAtendente,
      mensagemWrapperClasses,
      boxClasses,
      conteudoWrapperClasses,
    }
  },
}
</script>
